import React, { useState, useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppContext } from '../../contexts';
import Card from '../../components/elements/Card';
import Button from '../../components/elements/Button';
import Text from '../../components/fields/Text';
import IconAdd from '../../components/icons/IconAdd';
import styles from './styles.scoped.css';
import ScrollToTop from '../../components/elements/ScrollToTop';
import DataTable from '../../components/elements/DataTable';
import IconPencil from '../../components/icons/IconPencil';
import { useDebounce } from '../../utils/hooks';
import { fetchRoleUser, createRoleUser, editRoleUser, fetchPermissionUser } from './actions';
import RoleForm from '../../components/forms/RoleForm';
import { ActionIcon, Modal } from '@mantine/core';
import { useNavigate } from 'react-router-dom';

export default function Role() {
  const { setBreadcrumbs } = useContext(AppContext);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [search, setSearch] = useState('');
  const [modalForm, setModalForm] = useState(false);
  const [detail, setDetail] = useState({});
  const { dataRole, isLoadingRole, dataSubmitUpdateRole,
    isLoadingSubmitRole, isLoadingSubmitUpdateRole } = useSelector((state) => state.role);
  const { data, meta } = dataRole;
  const debouncedSearch = useDebounce(search, 500);

  const renderPermitionFlag = (value) => {
    return (
      <div className={styles.flagContainer}>
        {value?.map((val) => {
          return (
            <span className={styles.flag} key={val.permitionId}>{val.name}</span>
          );
        })}
      </div>);
  };

  useEffect(() => {
    let reload = null;
    if (dataSubmitUpdateRole && !isLoadingSubmitUpdateRole) {
      reload = setTimeout(() => navigate(0), 1500);
    }

    return () => clearTimeout(reload);
  }, [isLoadingSubmitUpdateRole, dataSubmitUpdateRole]);

  const handleEditData = (value) => {
    const dataOptions = value?.permitions?.map((val) => val.permitionId);
    setDetail({
      role: value.name,
      roleId: value.roleId,
      userType: value.userType,
      permissions: dataOptions
    });
    setModalForm(true);
  };

  const renderActionDisplay = (value) => {
    return (
      <div className={styles.actionContainer}>
        <ActionIcon
          onClick={() => handleEditData(value)}
          title={'Edit'}
        >
          <IconPencil style={{ fill: 'white' }} />
        </ActionIcon>
      </div>);
  };

  const column = [
    { heading: 'Nama', value: 'name', className: '' },
    { heading: 'Tipe User', value: (data) => data.userType === 'superadmin' ? 'CRUD + Download + Upload' : 'CRUD', className: '' },
    { heading: 'Permission',
      value: (value) => renderPermitionFlag(value.permitions),
      className: ''
    },
    {
      heading: 'Action',
      value: (value) => renderActionDisplay(value),
      className: '',
    },
  ];

  const handleOpenModalForm = () => {
    setDetail({});
    setModalForm(true);
  };
  const handleSubmit = (payload) => {
    const listIdPermissions = payload?.permissions?.map((val) => {
      return { permitionId: val };
    });
    const modPayload = {
      name: payload.role,
      userType: payload.userType,
      permitions: listIdPermissions
    };
    if (Object.keys(detail).length === 0) {
      dispatch(createRoleUser(modPayload));
    } else {
      dispatch(editRoleUser({ ...modPayload, roleId: payload.roleId }));
    }
    setModalForm(false);
  };
  const fetchListRoleUser = (scrollId) => {
    dispatch(fetchRoleUser(scrollId, search));
  };
  useEffect(() => {
    setBreadcrumbs(['Role']);
    dispatch(fetchPermissionUser());
  }, []);

  useEffect(() => {
    fetchListRoleUser();
  }, [debouncedSearch, isLoadingSubmitUpdateRole, isLoadingSubmitRole]);

  return (
    <main className={styles.root}>
      <Card className={styles.toolBox}>
        <Button
          className={styles.button}
          onClick={() => handleOpenModalForm()}
        >
          <IconAdd style={{ fill: '#FFFFFF' }} />
          <span>Tambah Role</span>
        </Button>
        <form className={styles.searchForm}>
          <Text
            hideLabel
            inputProps={{
              placeholder: 'Cari data...',
              value: search,
              icon: 'ic-search.svg',
              onChange: (e) => setSearch(e.target.value),
            }}
          />
        </form>
      </Card>
      <Card>
        <div className={styles['table-container']}>
          <DataTable
            className={styles.table}
            column={column}
            data={data}
            endTreshould={500}
            loading={isLoadingRole}
            meta={meta}
            onEndReached={() => fetchListRoleUser(meta.page)}
            onRefresh={fetchListRoleUser}
            withIndex
          />
        </div>
      </Card>
      <ScrollToTop />
      <Modal
        centered onClose={() => setModalForm(false)}
        opened={modalForm}
        size="lg"
        withCloseButton={false}
      >
        <RoleForm handleSubmit={handleSubmit} initialValues={detail} />
      </Modal>
    </main>
  );
}
